<template>
  <div>
    <v-row>
      <v-col>
        <v-subheader class="font-italic font-weight-light py-0"
          >Creazione Nuova Zona
        </v-subheader>
        <v-row class="mt-4 mb-6">
          <v-subheader class="font-italic font-weight-light">
            <v-btn :disabled="minNumberInternalZones" class="mr-3" small fab @click="removeZone(true)"
              ><v-icon>mdi-minus</v-icon></v-btn
            >
            <v-btn :disabled="maxNumberZones" class="mr-3" small fab @click="addZone(true)"
              ><v-icon>mdi-plus</v-icon></v-btn
            >
            <StandardColorPicker
              v-model="colorInternalZone"
            ></StandardColorPicker>
            <p class="ma-3">Colore Zona Interna</p></v-subheader
          >
        </v-row>
        <v-row class="mb-3">
          <v-subheader class="font-italic font-weight-light">
            <v-btn :disabled="minNumberExternalZones" class="mr-3" small fab @click="removeZone(false)"
              ><v-icon>mdi-minus</v-icon></v-btn
            >
            <v-btn :disabled="maxNumberZones" class="mr-3" small fab @click="addZone(false)"
              ><v-icon>mdi-plus</v-icon></v-btn
            >

            <StandardColorPicker
              v-model="colorExternalZone"
            ></StandardColorPicker>
            <p class="ma-3">Colore Zona Esterna</p></v-subheader
          >
        </v-row>
      </v-col>
    </v-row>
    <v-expansion-panels v-model="panel" flat class="pr-4">
      <v-expansion-panel v-model="panel" > 
        <v-expansion-panel-header hide-actions v-slot="{ open }">
          <v-row no-gutters>
            <v-col cols="8" class="text--secondary">
              <v-fade-transition leave-absolute>
                <span v-if="open" key="0"  class="font-italic font-weight-light"> Applica modifiche </span>
                <span v-else key="1"  class="font-italic font-weight-light"> Opzioni Zone </span>
              </v-fade-transition>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content  >
          <v-checkbox
            hide-details
            class="ml-3 font-italic font-weight-light"
            v-model="deletable"
            label="Elimina"
          ></v-checkbox>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import StandardColorPicker from "@/components/common/StandardColorPicker.vue";

export default {
  components: {
    StandardColorPicker,
  },
  data() {
    return {
      colorInternalZone: "",
      colorExternalZone: "",
      deletable: false,
      panel:0
    };
  },
  props: {
    maxNumberZones: {
      type: Boolean,
      default: false
    },
    minNumberInternalZones: {
      type: Boolean,
      default: false
    },
    minNumberExternalZones: {
      type: Boolean,
      default: false
    }
  },
  mounted() {},
  methods: {
    addZone(isInternal) {
      this.$emit("add-zone", isInternal);
    },
    removeZone(isInternal) {
      this.$emit("remove-zone", isInternal);
    },
  },
  watch: {
    deletable(newVal) {
      this.$emit("deletable-zone", newVal);
    },
    colorInternalZone(newVal) {
      this.$emit("change-color-internal", newVal);
    },
    colorExternalZone(newVal) {
      this.$emit("change-color-external", newVal);
    },
  },
};
</script>

<style>
</style>